/**
 * Page Statistiques — tableau de bord dédié du formateur.
 *
 * Fix 2026-09-02 : rubrique séparée (accessible via bouton "Statistiques"
 * dans l'accueil), plein écran (compact=false → affiche aussi le tableau
 * détaillé par matière).
 */
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, TrendingUp } from 'lucide-react';
import { StatsPanel } from '../components/StatsPanel';

export default function Statistiques() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-gray-950 text-slate-900 dark:text-gray-100">
      {/* Header sticky */}
      <header className="sticky top-0 z-30 bg-white dark:bg-gray-900 border-b border-slate-200 dark:border-gray-800">
        <div className="max-w-4xl mx-auto px-3 py-2.5 flex items-center gap-2.5">
          <button onClick={() => navigate('/formateur/accueil')}
            className="p-1.5 text-slate-500 dark:text-gray-400 hover:bg-slate-100 dark:hover:bg-gray-800 rounded transition"
            title="Retour à l'accueil">
            <ArrowLeft size={18} />
          </button>
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <div className="w-8 h-8 rounded-lg bg-slate-100 dark:bg-gray-800 flex items-center justify-center text-slate-600 dark:text-gray-400">
              <TrendingUp size={16} />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-wider text-slate-500 dark:text-gray-500 font-semibold leading-none">
                Tableau de bord
              </div>
              <div className="text-sm font-bold text-slate-900 dark:text-white leading-tight">
                Mes statistiques
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-3 py-3 pb-24">
        <StatsPanel />
      </main>
    </div>
  );
}
